<template>
  <AnimationComponent>
    <div
      :class="`flex flex-col items-center justify-between px-8 py-12 md:px-16 rounded-xl w-full gap-8 ${props.backgroundColor || 'bg-grey-light-50'}`"
    >
      <div class="w-full">
        <h2 class="text-3xl font-semibold mb-2 text-center">Subscribe to our newsletter</h2>
        <p class="text-xl font-light text-gray-600 text-center">
          Subscribe and stay in the loop about the latest brands and offerings.
        </p>
      </div>
      <SubscribeForm />
    </div>
  </AnimationComponent>
</template>

<script setup lang="ts">
import AnimationComponent from '@/components/AnimationComponent.vue';
import SubscribeForm from '@/components/SubscribeForm.vue';

const props = defineProps<{
  backgroundColor?: string;
}>();
</script>
